import { compose, withProps } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import CSSModules from 'react-css-modules';

import * as couponCalculation from '../../../../../redux/healthboard/requests/coupon-price-calculation-req';
import { appointmentDetailsActions } from '../../../../../redux/healthboard/appointment-details';
import {
  selectCouponCalculationData,
  selectCouponCalculationError,
  selectCouponVerificationData,
  selectCouponCalculationPending,
  selectCouponVerificationPending,
} from '../../../../../redux/healthboard/selectors';
import styles from './styles.styl';

const mapStateToProps = state => ({
  couponPending: selectCouponCalculationPending(state),
  couponErrors: selectCouponCalculationError(state),
  discount: selectCouponCalculationData(state),
  couponVerification: selectCouponVerificationData(state),
  couponVerificationPending: selectCouponVerificationPending(state),
});

const mapDispatchToProps = {
  calculateDiscount: couponCalculation.actions.send,
  clearCalculation: couponCalculation.actions.clear,
  clearPayment: appointmentDetailsActions.clearPayment,
  startPayment: appointmentDetailsActions.startPaymentProcess,
};

export const enhance = compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withProps(({ clearPayment, clearCalculation }) => ({
    clear: () => {
      clearPayment();
      clearCalculation();
    },
  })),
  CSSModules(styles, { allowMultiple: true }),
);



// WEBPACK FOOTER //
// ./src/components/Healthboard/Components/AppointmentDetailsPopup/AppointmentPaymentForm/enhance.js